module.exports = __webpack_public_path__ + "img/icon8.ef59144.webp";